<fieldset class="dt-fieldset" [class]="containerClass()">
  <legend class="checklist-task-label label">
    {{ labelText() }}
  </legend>

  @if (state().disabled()) {
    <output
      class="text-sm font-normal text-primary leading-6"
      [attr.id]="id()"
      role="note">
      {{ displayText() || placeholder() }}
    </output>
  } @else {
    @if (!isEditing()) {
      <div class="flex flex-row flex-wrap gap-x-1 gap-y-2 items-center">
        @if (state().value() && edited()) {
          <div class="text-tertiary">
            <svg-icon
              src="assets/svg/clock-plus.svg"
              svgClass="w-[1.375rem] h-[1.375rem]" />
          </div>
        }
        <span class="text-primary" data-testid="date-time-display">{{
          displayText() || placeholder()
        }}</span>
        <app-button
          [type]="ButtonType.TertiaryBrand"
          text="Edit"
          leftIcon="/assets/svg/edit-pencil.svg"
          [iconColor]="'text-button-secondary-color'"
          [disabled]="false"
          (clickEmitter)="enableEdit()" />
        <app-presence-avatars [viewers]="presenceViewers()" />
      </div>
    } @else {
      <div class="flex w-full">
        <div
          class="flex flex-row flex-wrap gap-x-4 gap-y-3 mt-1 w-full md:w-auto">
          <div
            class="flex flex-row gap-1 items-center w-full md:w-auto md:flex-wrap">
            @if (mode() !== 'date') {
              <nz-time-picker
                [formField]="editorForm.time"
                [nzFormat]="timeFormat()"
                [nzMinuteStep]="stepMinutes()"
                [nzSecondStep]="stepMinutes()"
                [nzAllowEmpty]="false"
                nzPopupClassName="clf-time-picker"
                [nzPlaceHolder]="timePlaceholder()"
                [nzInputReadOnly]="!keyboardInput()"
                class="checklist-input shrink-0 grow-0 !w-[5.5rem] md:!w-auto md:flex-none md:min-w-[6.875rem]"
                [class]="inputClass()"
                aria-label="Time" />
            }

            @if (allowTzChange()) {
              <app-dropdown
                [field]="offsetField"
                [options]="tzOptions"
                [searchable]="false"
                [clearable]="false"
                dropdownPosition="auto"
                appendTo="body"
                [id]="id() + '-offset'"
                containerClass="flex flex-col gap-1.5 flex-1 min-w-[6rem] md:grow-0 md:min-w-0" />
            }

            @if (mode() !== 'time') {
              <nz-date-picker
                [nzAllowClear]="false"
                [formField]="editorForm.date"
                nzFormat="yyyy-MM-dd"
                nzPlacement="topRight"
                nzDropdownClassName="clf-date-picker"
                [nzPlaceHolder]="datePlaceholder()"
                [nzInputReadOnly]="!keyboardInput()"
                (nzOnOpenChange)="onDatePickerOpenChange($event)"
                class="checklist-input flex-1 min-w-[8.75rem] md:flex-none md:w-[10.25rem]"
                [class]="inputClass()"
                aria-label="Date" />
            }
          </div>

          <div class="flex flex-row gap-3 ml-auto md:ml-0 items-center">
            <app-presence-avatars [viewers]="presenceViewers()" />
            <app-button
              [type]="ButtonType.Secondary"
              text="Undo"
              leftIcon="/assets/svg/refresh.svg"
              [iconColor]="'text-button-secondary-fg'"
              [disabled]="false"
              (clickEmitter)="onUndo()" />
            <app-button
              [type]="ButtonType.Primary"
              text="Save"
              leftIcon="/assets/svg/check.svg"
              [iconColor]="'text-button-secondary-fg'"
              [disabled]="false"
              (clickEmitter)="onSave()" />
          </div>
        </div>
      </div>
    }
  }
</fieldset>
